export default __webpack_public_path__ + "ca093a94bab066eebc92796345acfb0d.svg";